<template>
    <div class="container">
        <el-card class="form">
            <el-form
                ref="form"
                label-position="right"
                :rules="rules"
                label-width="130px"
                :model="form"
            >
                <el-form-item label="学校/研究所" prop="graduateSchool">
                    <el-input v-model="form.graduateSchool"></el-input>
                </el-form-item>
                <el-form-item label="学院" prop="college">
                    <el-input v-model="form.college"></el-input>
                </el-form-item>
                <el-form-item label="课题组" prop="topicName">
                    <el-input v-model="form.topicName"></el-input>
                </el-form-item>
                <el-form-item label="姓名" prop="userName">
                    <el-input v-model="form.userName"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="userMobile">
                    <el-input v-model="form.userMobile"></el-input>
                </el-form-item>
                <el-form-item label="QQ/微信" prop="userQq">
                    <el-input v-model="form.userQq"></el-input>
                </el-form-item>
                <el-form-item label="邮箱">
                    <el-input v-model="form.email"></el-input>
                </el-form-item>
                <el-form-item label="研究方向" prop="researchDirection">
                    <el-input v-model="form.researchDirection"></el-input>
                </el-form-item>
                <el-form-item label="是否关注公众号" prop="publicWxState">
                    <el-radio v-model="form.publicWxState" :label="1">是</el-radio>
                    <el-radio v-model="form.publicWxState" :label="0">否</el-radio>
                </el-form-item>
            </el-form>
            <el-button class="btn" type="success" @click="onSubmitValidate()">提交</el-button>
        </el-card>
        <Hot></Hot>
    </div>
</template>

<script>
import Hot from '../components/hot/Hot';
import * as apis from '../fetch/common';

export default {
    name: 'proindex',
    components: {
        Hot,
    },
    data() {
        return {
            form: {
                graduateSchool: '',
                college: '',
                topicName: '',
                userName: '',
                userMobile: '',
                userQq: '',
                userWx: '',
                email: '',
                researchDirection: '',
                publicWxState: 0,
            },
            rules: {
                graduateSchool: [{ required: true, message: '请输入学校/研究所' }],
                college: [{ required: true, message: '请输入学院' }],
                topicName: [{ required: true, message: '请输入课题组' }],
                userName: [{ required: true, message: '请输入姓名' }],
                userMobile: [{ required: true, message: '请输入手机号' }],
                userQq: [{ required: true, message: '请输入QQ/微信' }],
                userWx: [{ required: true, message: '请输入邮箱' }],
                researchDirection: [{ required: true, message: '请输入研究方向' }],
            },
        };
    },
    methods: {
        onSubmitValidate() {
            this.$refs['form'].validate(valid => {
                if (valid) {
                    this.onSubmit();
                } else {
                    return false;
                }
            });
        },
        onSubmit() {
            const params = { ...this.form };
            apis.saveProIndex(params).then(res => {
                this.$message.success('提交成功');
            });
        },
    },
};
</script>

<style lang="less" scoped>
.container {
    display: flex;
    justify-content: space-between;
}

.form {
    width: 895px;
    height: max-content;
    .btn {
        margin-left: 100px;
    }
}
</style>